module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grid container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "three ui buttons"
  }, [_c('a', {
    staticClass: "ui green button",
    attrs: {
      "href": _vm.defaultUrl
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v(_vm._s(_vm.lang.say('BTN_CONTINUE_SHOPPING')))]), _vm._v(" "), (_vm.inCart) ? _c('button', {
    staticClass: "ui button cleanCart",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeAllProducts
    }
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v(_vm._s(_vm.lang.say('BTN_CLEAN_CART')))]) : _vm._e(), _vm._v(" "), (_vm.inCart) ? _c('button', {
    staticClass: "ui blue button toShipping",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.lang.say('BTN_CHECKOUT'))), _c('i', {
    staticClass: "right chevron icon"
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3b8f536!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonCollection.vue
// module id = 380
// module chunks = 0